module.exports = __webpack_public_path__ + "static/image5-76628ec56cbe319c9197ebf6a4263d2d.jpg";